<template>
  <button>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6 h-6 text-red-600 hover:text-red-800 transition duration-200"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M9 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2h-1v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6H3a1 1 0 1 1 0-2h3V3zm2 2h2V4h-2v1zM7 6v14h10V6H7zm3 3a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0V9zm4 0a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0V9z"
        clip-rule="evenodd"
      />
    </svg>
  </button>
</template>

<script>
import { initFlowbite } from "flowbite";

export default {
  name: "DeleteIcon",
  mounted() {
    initFlowbite();
  },
};
</script>
<style scoped>
/* Add any additional styles if needed */
</style>
